import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { Utilities } from '../../../core/helper/util';
import { SelectInputComponent, SelectOption } from 'src/app/core/component/form-inputs/select-input/select-input.component';
import { TextInputComponent } from 'src/app/core/component/form-inputs/text-input/text-input.component';



@Component({
  selector: 'app-selectable-search',
  templateUrl: 'selectable-search.html',
  styleUrls: ['selectable-search.scss']
})
export class SelectableSearchPage implements OnInit {
  @ViewChild('searchbar') searchbar: TextInputComponent;
  @Input() items: SelectOption[] = [];
  @Input() selectTitle = 'Select Item';

  filteredItems: SelectOption[] = [];
  searchTerm = '';

  constructor(private modalCtrl: ModalController,) {
    this.loadData();
  }


  static async openSearchWindow(modalCtrl: ModalController, items: SelectOption[], title: string = 'Select Items') {
    const modal = await modalCtrl.create({ component: SelectableSearchPage, componentProps: { items, selectTitle: title } });
    await modal.present();
    const resp = await modal.onDidDismiss();

    if (resp.data != null) {
      console.log('Search modal dismissed with data: ', resp.data);
      return resp.data.value ?? '';
    }
    return null;
  }

  ngOnInit() {
    this.loadData();
  }

  async ionViewDidEnter() {
    setTimeout(() => {
      this.searchbar.setFocus();
    }, 350);
  }

  async find(ev: any) {
    this.searchTerm = (ev.target.value || '').toLowerCase();

    if (Utilities.stringEmpty(this.searchTerm)) {
      this.filteredItems = this.items;
    } else {
      this.filteredItems = this.items.filter(m => (
        (m.displayValue != null && m.displayValue.toLowerCase().includes(this.searchTerm)) ||
        (m.value != null && m.value.toString().toLowerCase().includes(this.searchTerm))
      ));
    }
  }

  cancel() {
    this.modalCtrl.dismiss();
  }

  select(sel: SelectOption) {
    this.modalCtrl.dismiss({ value: sel.value });
  }

  private loadData() {
    console.log('SelectableSearchPage: items', this.items);
    this.filteredItems = this.items;
  }
}
